import config from '../../Admin/Config.json'

export default function Advertise({ advertise }) {
 
  const { media, showinwebsite } = advertise;

  if (showinwebsite === 1) {
    return (
      <div className="advertise">
        <div className="advertise-img">
        
          <img src={config.awsMediaPath + media} alt="remove rediate" />
        </div>
      </div>
    );
  } else {
    
    return <></>;
  }
}
